import { useParams } from 'react-router-dom';

import { AdminOrganisationLayout } from './admin-organisation-layout';
import { Permission } from '../../../../../../../backend/src/auth/permissions/permission';
import { usePlatformPermissionCheck } from '@/hooks/usePlatformPermissionCheck';
import { Permissions } from '@/new/pages/organisation-settings/components/roles';

export function AdminManageRoles() {
  const { organisationId } = useParams();
  if (!organisationId) return null;

  usePlatformPermissionCheck(Permission.PlatformManageRoles);

  return (
    <AdminOrganisationLayout>
      <div className="mb-8 flex min-h-0 flex-1 flex-col px-8">
        <Permissions
          organisationId={organisationId}
          description="Changes here affect access for users in another organisation. Review each permission carefully before saving, especially permissions that grant access to all Matters or organisation-wide settings."
        />
      </div>
    </AdminOrganisationLayout>
  );
}
